module.exports = __webpack_public_path__ + "img/audit.9cc166e5.svg";